import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PaymentsPaymentsResponseDataDialogComponent } from '../payments-payments-response-data-dialog/payments-payments-response-data-dialog.component';

@Component({
  selector: 'app-payments-payments-list-card',
  templateUrl: './payments-payments-list-card.component.html',
  styleUrls: ['./payments-payments-list-card.component.scss']
})
export class PaymentsPaymentsListCardComponent implements OnInit {

  @Input() data;
  creationDateOrder;
  centerOrder;
  orderIdOrder;
  paymentIdentifierOrder;
  gatewayOrder;
  statusOrder;
  typeOrder;
  bankOrder;
  dataTransactionOrder;

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
    this.resetSortOrders();
  }


  public resetSortOrders() {
    this.creationDateOrder = 0;
    this.centerOrder = 0;
    this.orderIdOrder = 0;
    this.paymentIdentifierOrder = 0;
    this.gatewayOrder = 0;
    this.statusOrder = 0;
    this.typeOrder = 0;
    this.bankOrder = 0;
    this.dataTransactionOrder = 0;
  }

  public sortBy(attribute) {
    switch (attribute) {
      case 'creationDate':
        this.creationDateOrder = (this.creationDateOrder === 0) ? 1 : (this.creationDateOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.Datetime = a.Datetime ? a.Datetime : 0;
            b.Datetime = b.Datetime ? b.Datetime : 0;
            return (a.Datetime < b.Datetime) ? -this.creationDateOrder : (a.Datetime) ? this.creationDateOrder : 0;
          });
        break;
      case 'centerName':
        this.centerOrder = (this.centerOrder === 0) ? 1 : (this.centerOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.CenterName = a.CenterName ? a.CenterName : ' ';
            b.CenterName = b.CenterName ? b.CenterName : ' ';
            return (a.CenterName.toUpperCase() < b.CenterName.toUpperCase()) ? -this.centerOrder : (a.CenterName.toUpperCase() > b.CenterName.toUpperCase()) ? this.centerOrder : 0;
          });
        break;
      case 'orderId':
        this.orderIdOrder = (this.orderIdOrder === 0) ? 1 : (this.orderIdOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.OrderId = a.OrderId ? a.OrderId : ' ';
            b.OrderId = b.OrderId ? b.OrderId : ' ';
            return (a.OrderId.toUpperCase() < b.OrderId.toUpperCase()) ? -this.orderIdOrder : (a.OrderId.toUpperCase() > b.OrderId.toUpperCase()) ? this.orderIdOrder : 0;
          });
        break;
      case 'paymentIdentifier':
        this.paymentIdentifierOrder = (this.paymentIdentifierOrder === 0) ? 1 : (this.paymentIdentifierOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.PaymentIdentifier = a.PaymentIdentifier ? a.PaymentIdentifier : ' ';
            b.PaymentIdentifier = b.PaymentIdentifier ? b.PaymentIdentifier : ' ';
            return (a.PaymentIdentifier.toUpperCase() < b.PaymentIdentifier.toUpperCase()) ? -this.paymentIdentifierOrder : (a.PaymentIdentifier.toUpperCase() > b.PaymentIdentifier.toUpperCase()) ? this.paymentIdentifierOrder : 0;
          });
        break;
      case 'gateway':
        this.gatewayOrder = (this.gatewayOrder === 0) ? 1 : (this.gatewayOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.Gateway = a.Gateway ? a.Gateway : ' ';
            b.Gateway = b.Gateway ? b.Gateway : ' ';
            return (a.Gateway.toUpperCase() < b.Gateway.toUpperCase()) ? -this.gatewayOrder : (a.Gateway.toUpperCase() > b.Gateway.toUpperCase()) ? this.gatewayOrder : 0;
          });
        break;
      case 'status':
        this.statusOrder = (this.statusOrder === 0) ? 1 : (this.statusOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.Status = a.Status ? a.Status : ' ';
            b.Status = b.Status ? b.Status : ' ';
            return (a.Status.toUpperCase() < b.Status.toUpperCase()) ? -this.statusOrder : (a.Status.toUpperCase() > b.Status.toUpperCase()) ? this.statusOrder : 0;
          });
        break;
      case 'type':
        this.typeOrder = (this.typeOrder === 0) ? 1 : (this.typeOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TransactionType = a.TransactionType ? a.TransactionType : ' ';
            b.TransactionType = b.TransactionType ? b.TransactionType : ' ';
            return (a.TransactionType.toUpperCase() < b.TransactionType.toUpperCase()) ? -this.typeOrder : (a.TransactionType.toUpperCase() > b.TransactionType.toUpperCase()) ? this.typeOrder : 0;
          });
        break;
      case 'bank':
        this.bankOrder = (this.bankOrder === 0) ? 1 : (this.bankOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.Bank = a.Bank ? a.Bank : ' ';
            b.Bank = b.Bank ? b.Bank : ' ';
            return (a.Bank.toUpperCase() < b.Bank.toUpperCase()) ? -this.typeOrder : (a.Bank.toUpperCase() > b.Bank.toUpperCase()) ? this.typeOrder : 0;
          });
        break;
      case 'bank':
        this.dataTransactionOrder = (this.dataTransactionOrder === 0) ? 1 : (this.dataTransactionOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.DataTransaction = a.DataTransaction ? a.DataTransaction : ' ';
            b.DataTransaction = b.DataTransaction ? b.DataTransaction : ' ';
            return (a.DataTransaction.toUpperCase() < b.DataTransaction.toUpperCase()) ? -this.dataTransactionOrder : (a.DataTransaction.toUpperCase() > b.Bank.toUpperCase()) ? this.dataTransactionOrder : 0;
          });
        break;
    }
  }

  public openDataResponse(dataResponse) {
    this.dialog.open(PaymentsPaymentsResponseDataDialogComponent, { data: { dataResponse} });
  }

}
